interface MapEmbedProps {
  location: string;
  zoom?: number;
  title?: string;
}

const MapEmbed: React.FC<MapEmbedProps> = ({
  location = "Ceylon Hospital, No. 228/1, Asiri Mawatha, Kandy Rd, Yakkala 11870",
  zoom = 10,
  title = "Ceylon Hospital Location",
}) => {
  const encodedLocation = encodeURIComponent(location);
  const mapUrl = `https://maps.google.com/maps?q=${encodedLocation}&t=m&z=${zoom}&output=embed&iwloc=near`;

  return (
    <section className="map-container">
      <iframe
        src={mapUrl}
        title={title}
        aria-label={title}
        className="w-full h-96 border-0"
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />
    </section>
  );
};

export default MapEmbed;
